import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCountdown } from "@/hooks/useCountdown";
import { OrderStatusEnum } from "@/modules/order/schema";
interface OrderCountdownProps {
  orderStatus: OrderStatusEnum;
  createdAt: string;
  onOrderExpired?: () => void;
  onExpiredRefetch?: () => void;
  displayMode?: "desktop" | "mobile";
  fallbackStatus?: React.ReactNode;
}
const OrderCountdown: React.FC<OrderCountdownProps> = t0 => {
  const $ = _c(22);
  const {
    orderStatus,
    createdAt,
    onOrderExpired,
    onExpiredRefetch,
    displayMode: t1,
    fallbackStatus
  } = t0;
  const displayMode = t1 === undefined ? "desktop" : t1;
  const {
    t
  } = useTranslation();
  const showCountdown = orderStatus === OrderStatusEnum.WAIT_PAY;
  let t2;
  if ($[0] !== onOrderExpired) {
    t2 = () => {
      if (onOrderExpired) {
        onOrderExpired();
      }
    };
    $[0] = onOrderExpired;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== createdAt || $[3] !== onExpiredRefetch || $[4] !== t2) {
    t3 = {
      startTime: createdAt,
      durationInSeconds: 900,
      onEnd: t2,
      onExpiredRefetch
    };
    $[2] = createdAt;
    $[3] = onExpiredRefetch;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    formattedTime
  } = useCountdown(t3);
  const formattedTimeLeft = `${formattedTime.minutes}:${formattedTime.seconds}`;
  if (!showCountdown) {
    if (React.isValidElement(fallbackStatus)) {
      let t4;
      if ($[6] !== fallbackStatus) {
        t4 = <>{fallbackStatus}</>;
        $[6] = fallbackStatus;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      return t4;
    }
    const t4 = displayMode === "desktop" ? "font-bold" : "";
    let t5;
    if ($[8] !== fallbackStatus || $[9] !== t4) {
      t5 = <div className={t4}>{fallbackStatus}</div>;
      $[8] = fallbackStatus;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  if (displayMode === "mobile") {
    let t4;
    if ($[11] !== formattedTimeLeft) {
      t4 = <div className="flex flex-col items-end text-destructive"><span className="text-xs">{formattedTimeLeft}</span></div>;
      $[11] = formattedTimeLeft;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    return t4;
  }
  let t4;
  if ($[13] !== t) {
    t4 = t("order.item.orderCloseTimeLabel");
    $[13] = t;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = <span className="text-xs mt-1">{t4}</span>;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== formattedTimeLeft) {
    t6 = <span className="text-xs">{formattedTimeLeft}</span>;
    $[17] = formattedTimeLeft;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="flex flex-col items-center text-destructive">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default OrderCountdown;